<script>
	import { Router, Link, Route } from "svelte-routing";
	import IconShelf from './IconShelf.svelte';
	import Reel from './Reel.svelte';
	import Map from './Map.svelte';
	import { user, books, book_lists  } from './stores.js';

	export let id;
	let book;

	$: book = books[id];


	import { onMount, afterUpdate } from "svelte";

	afterUpdate(() => {
		window.scrollTo(0, 0);
	});
</script>

<style>
	main {
		padding: 50px;
	}

	h1 {
		margin-bottom: 60px;
	}
	.subtitle {
		font-size: 18px;
		color: #666;
		padding-top: 10px;
	}

	.info-container {
		display: flex;
	}
	.info-container > div {
		padding: 20px;
	}
	.desc {
		width: 70%;
		/*flex-grow: 2;*/
		white-space: pre-line;
	}
	.info-table {
		/*flex-grow: 2;*/
	}
	.cover {
		display: block;
		margin: 0 auto;
	}

	.mag {
		max-width: 20px;
		max-height: 20px;
		vertical-align: middle;
	}
	.map-info {
		text-align: center;
		font-size: 14px;
	}
</style>

<main>
	<h1>
		{book.name}
		<div class="subtitle">{book.author || ""}</div>
	</h1>

	<div class="info-container">
		<div class="desc">Harry Potter's life is miserable. His parents are dead and he's stuck with his heartless relatives, who force him to live in a tiny closet under the stairs. But his fortune changes when he receives a letter that tells him the truth about himself: he's a wizard. A mysterious visitor rescues him from his relatives and takes him to his new home, Hogwarts School of Witchcraft and Wizardry.

After a lifetime of bottling up his magical powers, Harry finally feels like a normal kid. But even within the Wizarding community, he is special. He is the boy who lived: the only person to have ever survived a killing curse inflicted by the evil Lord Voldemort, who launched a brutal takeover of the Wizarding world, only to vanish after failing to kill Harry.

Though Harry's first year at Hogwarts is the best of his life, not everything is perfect. There is a dangerous secret object hidden within the castle walls, and Harry believes it's his responsibility to prevent it from falling into evil hands. But doing so will bring him into contact with forces more terrifying than he ever could have imagined.

Full of sympathetic characters, wildly imaginative situations, and countless exciting details, the first installment in the series assembles an unforgettable magical world and sets the stage for many high-stakes adventures to come.</div>
		<div class="info-table">
			<img class="cover" src={book.image} />
			<br>

			<div><strong>Pages:</strong> 300</div>
			<div><strong>Rating:</strong> 5/5</div>

			<br>
			<br>

			{#if book.available}
				<IconShelf icon="shelf" /> In shelf<br>
				1.4 FANTASIA
				<br><br><br>
			{:else}
				<IconShelf icon="no" /> Reservable<br>
				<div>The book is not available in this library, but you can reserve it.</div>
			{/if}


			{#if book.available}
				<div class="map-info">
					<strong>Location</strong>
				</div>
				<Map />
				<div class="map-info">
					<img class="mag" src="/magnifying-lens-with-plus-sign.png">
					Tap to enlarge
				</div>
			{/if}
		</div>
	</div>

	<Reel small name="Related books" books={book_lists.new} />
</main>
